var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01514 14.4248C3.56742 14.4248 4.01514 14.8725 4.01514 15.4248V19.4248C4.01514 19.69 4.12049 19.9444 4.30803 20.1319C4.49557 20.3194 4.74992 20.4248 5.01514 20.4248H19.0151C19.2804 20.4248 19.5347 20.3194 19.7222 20.1319C19.9098 19.9444 20.0151 19.69 20.0151 19.4248V15.4248C20.0151 14.8725 20.4629 14.4248 21.0151 14.4248C21.5674 14.4248 22.0151 14.8725 22.0151 15.4248V19.4248C22.0151 20.2205 21.6991 20.9835 21.1365 21.5461C20.5738 22.1087 19.8108 22.4248 19.0151 22.4248H5.01514C4.21949 22.4248 3.45643 22.1087 2.89382 21.5461C2.33121 20.9835 2.01514 20.2205 2.01514 19.4248V15.4248C2.01514 14.8725 2.46285 14.4248 3.01514 14.4248Z",
    fill: "#A793F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.308 2.7177C11.6986 2.32717 12.3317 2.32717 12.7222 2.7177L17.7222 7.7177C18.1128 8.10822 18.1128 8.74139 17.7222 9.13191C17.3317 9.52244 16.6986 9.52244 16.308 9.13191L12.0151 4.83902L7.72224 9.13191C7.33172 9.52244 6.69855 9.52244 6.30803 9.13191C5.91751 8.74139 5.91751 8.10822 6.30803 7.7177L11.308 2.7177Z",
    fill: "#A793F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0151 2.4248C12.5674 2.4248 13.0151 2.87252 13.0151 3.4248V15.4248C13.0151 15.9771 12.5674 16.4248 12.0151 16.4248C11.4629 16.4248 11.0151 15.9771 11.0151 15.4248V3.4248C11.0151 2.87252 11.4629 2.4248 12.0151 2.4248Z",
    fill: "#A793F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2d1779ac18c72a72db4be1c3cfe1fbee.svg";
export { ForwardRef as ReactComponent };